import log from 'salvo-lite/log'
import Helpers from '../helpers/Helpers'

class Product {
    constructor (theme, elem) {
        this.theme = theme
        this._name = this.constructor.name
        this._elem = elem
        this.options = Object.assign({
            enableHistoryState: true
        }, JSON.parse(this._elem.dataset.options || '{}'))
        this.product = this._elem.querySelector('[data-product-json]') ? JSON.parse(this._elem.querySelector('[data-product-json]').innerHTML) : null
        this.singleOptionSelectors = this._elem.querySelectorAll('[data-single-option-selector]')
        this.currentVariant = this.getVariantFromOptions()
        this.originalSelectors = this._elem.querySelectorAll('[data-product-select]')
        this.priceWrappers = this._elem.querySelectorAll('[data-price-wrapper]')
        this.compareWrappers = this._elem.querySelectorAll('[data-compare-wrapper]')
        this.productPrices = this._elem.querySelectorAll('[data-product-price]')
        this.productComparePrices = this._elem.querySelectorAll('[data-compare-price]')
        this.quantitySelects = this._elem.querySelectorAll('[data-quantity]')
        this.productImages = this._elem.querySelectorAll('[data-image-for]')
        this.combinedTitles = this._elem.querySelectorAll('[data-combined-title]')
        this.addToCarts = this._elem.querySelectorAll('[data-add-to-cart]')
        this.addToCartTexts = this._elem.querySelectorAll('[data-add-to-cart-text]')
        this.deliveryTimeArr = this._elem.querySelector('[data-delivery-json]') ? JSON.parse(this._elem.querySelector('[data-delivery-json]').innerHTML) : null
        this.stockObj = this._elem.querySelector('[data-stock-json]') ? JSON.parse(this._elem.querySelector('[data-stock-json]').innerHTML) : null
        this.stockMessageElems = this._elem.querySelectorAll('[data-stock-message]')

        this.stockStatusObj = this._elem.querySelector('[data-stock-status]') ? JSON.parse(this._elem.querySelector('[data-stock-status]').dataset.stockStatus) : null
        this.stockStatus = this._elem.querySelector('[data-stock-status]')
    }

    triggerEvent (elem = this._elem, name = 'event', data = {}) {
        elem.dispatchEvent(new CustomEvent(name, { detail: data }))
    }

    onInit () {
        log.debug(this._name, 'Initiating', this)

        if (this.product === null) {
            return false
        }

        for (let quantitySelect of this.quantitySelects) {
            quantitySelect.addEventListener('change', (e) => {
                for (let otherSelector of this.quantitySelects) {
                    if (otherSelector !== quantitySelect) {
                        otherSelector.value = quantitySelect.value
                        otherSelector.dispatchEvent(new CustomEvent('update-choices', { detail: quantitySelect.value }))
                    }
                }
            })
        }

        for (let optionSelector of this.singleOptionSelectors) {
            optionSelector.addEventListener('change', (e) => {
                // for (let otherSelector of this.singleOptionSelectors) {
                //     if (otherSelector.dataset.index === optionSelector.dataset.index && otherSelector !== optionSelector) {
                //         otherSelector.value = optionSelector.value
                //         otherSelector.dispatchEvent(new CustomEvent('update-choices', { detail: optionSelector.value }))
                //     }
                // }
                this.onSelectChange()
            })
        }

        this.onSelectChange()

        log.debug(this._name, 'Initated', this)
    }

    /**
   * Event handler for when a variant input changes.
   */
    onSelectChange () {
        let variant = this.getVariantFromOptions()

        this.updateAddToCartState(variant)
        if (!variant) {
            return
        }

        this.updateMasterSelect(variant)
        this.updateProductPrices(variant)
        this.switchToVariantImage(variant)

        if (this.deliveryTimeArr) {
            this.updateDeliveryTime(variant)
        }

        this.updateStockStatus(variant)
        this.updateVariantTitles(variant)
        this.currentVariant = variant
        this.triggerEvent(this.elem, 'variantChange', variant)

        var saleTags = document.querySelectorAll('.left-area .hc-sale-tag')
        if (variant.available && variant.compare_at_price && variant.compare_at_price > variant.price) {
            var discount = (variant.compare_at_price - variant.price) * 100 / variant.compare_at_price
            if (discount !== undefined) {
                for (var i = 0; i < saleTags.length; i++) {
                    saleTags[i].childNodes[0].textContent = discount.toFixed(0) + '%'
                    saleTags[i].style.display = 'block'
                }
            } else {
                for (var x = 0; x < saleTags.length; x++) {
                    saleTags[i].style.display = 'none'
                }
            }
        } else {
            for (var y = 0; y < saleTags.length; y++) {
                saleTags[i].style.display = 'none'
            }
        }

        if (this.options.enableHistoryState) {
            this.updateHistoryState(variant)
        }
    }

    updateVariantTitles (variant) {
        for (let elem of this.combinedTitles) {
            if (elem.nodeName === 'INPUT') {
                elem.value = `${this.product.title} - ${variant.title}`
            } else {
                elem.textContent = `${this.product.title} - ${variant.title}`
            }
        }
    }

    updateDeliveryTime (variant) {
        if (document.querySelector('#delivery_time')) {
            for (var i = 0; i < this.deliveryTimeArr.deliveryTimeArr.length; i++) {
                if (this.deliveryTimeArr.deliveryTimeArr[i].id === variant.id) {
                    document.querySelector('#delivery_time').value = this.deliveryTimeArr.deliveryTimeArr[i].delivery_time
                    break
                }
            }
        }
    }

    updateStockStatus (variant) {
        let foundVariant = null
        for (let stockVar of this.stockObj.stockArr) {
            if (stockVar.id === variant.id) {
                foundVariant = stockVar
            }
        }
        if (foundVariant.message) {
            for (let el of this.stockMessageElems) {
                el.innerHTML = foundVariant.message
            }
        } else {
            for (let el of this.stockMessageElems) {
                el.innerHTML = 'No Variant Found'
            }
        }
    }

    /**
   * Update history state for product deeplinking
   *
   * @param {object} variant - Currently selected variant
   */
    updateHistoryState (variant) {
        if (!history.replaceState || !variant) {
            return
        }

        let newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id
        window.history.replaceState({ path: newurl }, '', newurl)
    }

    /**
   * Updates the DOM state of the add to cart button
   *
   * @param {boolean} enabled - Decides whether cart is enabled or disabled
   * @param {string} text - Updates the text notification content of the cart
   */
    updateAddToCartState (variant) {
        if (variant) {
            for (let priceWrapper of this.priceWrappers) {
                priceWrapper.classList.remove('hide')
            }
        } else {
            for (let addToCart of this.addToCarts) {
                addToCart.setAttribute('disabled', 'disabled')
            }
            for (let addToCartText of this.addToCartTexts) {
                addToCartText.innerHTML = this.theme.locale.make_a_selection
            }
            // for (let priceWrapper of this.priceWrappers) {
            //     priceWrapper.classList.add('hide')
            // }
            return
        }

        if (variant.available) {
            for (let addToCart of this.addToCarts) {
                addToCart.removeAttribute('disabled')
            }
            for (let addToCartText of this.addToCartTexts) {
                addToCartText.innerHTML = this.theme.locale.add_to_cart
            }
        } else {
            for (let addToCart of this.addToCarts) {
                addToCart.setAttribute('disabled', 'disabled')
            }
            for (let addToCartText of this.addToCartTexts) {
                addToCartText.innerHTML = this.theme.locale.sold_out
            }
        }
    }

    switchToVariantImage (variant) {
        for (let productImage of this.productImages) {
            if (productImage.dataset.imageFor) {
                let idArray = productImage.dataset.imageFor.split(',')
                if (idArray.includes(variant.id.toString())) {
                    let mainSlider = this.theme.getComponentsById('mainProductSlider')
                    mainSlider.goToSlide(productImage.dataset.slickIndex)
                }
            }
        }
    }

    /**
   * Updates the DOM with specified prices
   *
   * @param {string} productPrice - The current price of the product
   * @param {string} comparePrice - The original price of the product
   */
    updateProductPrices (variant) {
        for (let productPrice of this.productPrices) {
            if (variant.compare_at_price > variant.price) {
                productPrice.innerHTML = `${this.formatMoney(variant.price)}`
            } else {
                productPrice.innerHTML = this.formatMoney(variant.price)
            }
        }

        for (let compareWrapper of this.compareWrappers) {
            if (variant.compare_at_price > variant.price) {
                compareWrapper.classList.remove('hide')
            } else {
                compareWrapper.classList.add('hide')
            }
        }

        for (let productComparePrice of this.productComparePrices) {
            if (variant.compare_at_price > variant.price) {
                productComparePrice.innerHTML = `${this.formatMoney(variant.compare_at_price)}`
            } else {
                productComparePrice.innerHTML = ''
                productComparePrice.classList.add('hide')
            }
        }
    }

    /**
   * Update hidden master select of variant change
   *
   * @param {object} variant - Currently selected variant
   */
    updateMasterSelect (variant) {
        for (let originalSelector of this.originalSelectors) {
            originalSelector.value = variant.id
        }
    }

    getCurrentOptions () {
        let currentOptions = []
        for (let optionSelector of this.singleOptionSelectors) {
            let type = optionSelector.getAttribute('type')
            let currentOption = {}
            let alreadyDone = false
            for (let option of currentOptions) {
                if (option.index === optionSelector.dataset.index) {
                    alreadyDone = true
                }
            }
            if (alreadyDone) continue
            if (type === 'radio' || type === 'checkbox') {
                if (optionSelector.checked) {
                    currentOption.value = optionSelector.value
                    currentOption.index = optionSelector.dataset.index
                    currentOptions.push(currentOption)
                } else {
                    currentOptions.push(false)
                }
            } else {
                currentOption.value = optionSelector.value
                currentOption.index = optionSelector.dataset.index
                currentOptions.push(currentOption)
            }
        }

        // remove any unchecked input values if using radio buttons or checkboxes
        currentOptions = this.compact(currentOptions)
        return currentOptions
    }

    /**
   * Find variant based on selected values.
   *
   * @param  {array} selectedValues - Values of variant inputs
   * @return {object || undefined} found - Variant object from product.variants
   */
    getVariantFromOptions () {
        let selectedValues = this.getCurrentOptions()
        let variants = this.product.variants
        let found = false

        for (let variant of variants) {
            var satisfied = true

            for (let option of selectedValues) {
                if (satisfied) {
                    satisfied = (option.value === variant[option.index])
                }
            }

            if (satisfied) {
                found = variant
            }
        }

        return found || null
    }

    compact (array) {
        var index = -1
        var length = array == null ? 0 : array.length
        var resIndex = 0
        var result = []

        while (++index < length) {
            var value = array[index]
            if (value) {
                result[resIndex++] = value
            }
        }
        return result
    }

    formatMoney (amount) {
        return Helpers.formatMoney(amount)
    }
}

export default Product



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Product.js